
import {throwError as observableThrowError,  Observable ,  forkJoin } from 'rxjs';

import {refCount, publishReplay, catchError} from 'rxjs/operators';
import { Injectable, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core'
//import { Http, Headers, Response, RequestOptions, URLSearchParams} from '@angular/http'
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http'



import { AuthService } from './auth.service'
import { SharedMethodsModule } from '../insa-custom-scripts/sharedMethods'

import { CrossRatesModel } from '../insa-models/crossRates.model'
import { PortfolioModel } from '../insa-models/portfolio.model'
import { ChartModel } from '../insa-models/chart.model'
import { SecurityPricesModel } from '../insa-models/securityPrices.model'
import { CurrencyModel } from '../insa-models/currency.model'
import { TransactionModel } from '../insa-models/transaction.model'
import { ReportModel } from '../insa-models/report.model'
import { PerformancePivotListModel } from '../insa-models/performancePivot.model'
import { TransactionVolumeModel } from '../insa-models/transVolume.model'
import { PortfolioPerformanceDetailsModel } from '../insa-models/portfolioPerformanceDetails.model'
import { NewsDataModel } from '../insa-models/news-data.model'
import { appStateProvider } from '../insa-providers/AppStateProvider'
import { appConfig } from '../../insaweb.config'
import { LocalizeService } from './localize.service';
//import { jsonpFactory } from '@angular/http/src/http_module';

@Injectable()
export class InsaService implements OnDestroy {

    private language = 'en';
    private hostAddress = appConfig.insaServiceAddress;
    private servicesURL = "/InsaService";

    portfolios: any; // PortfolioModel[] = new Array<PortfolioModel>(); holi
    chartDataAssetCategory: any; // ChartModel[] = new Array<ChartModel>(); holi
    chartDataPerformanceDetails: any; //    ChartModel[] = new Array<ChartModel>(); holi
    chartDataCurrAnalysis: any; //  ChartModel[] = new Array<ChartModel>(); holi
    transactions: any; //   TransactionModel[] = new Array<TransactionModel>(); holi
    crossRates: any; // CrossRatesModel[] = new Array<CrossRatesModel>(); holi
    maxValPerformanceDetails: number;
    minValPerformanceDetails: number;
    currencies: CurrencyModel[] = new Array<CurrencyModel>();
    stateSubscription;
    report: any; // ReportModel;    holi
    transactionVolume: any; //   TransactionVolumeModel[] = new Array<TransactionVolumeModel>(); holi
    portfolioPerformanceDetails: any;   // PortfolioPerformanceDetailsModel[];  holi
    newsData: any; //   NewsDataModel[] = new Array<NewsDataModel>();   holi
    allPortfoliosNoLiquidity: PortfolioModel[] = new Array<PortfolioModel>();
    authServiceSubscription;
    secPrices: any;
    pdfReport: any; //string = undefined;
    performancePivotList: any; //   PerformancePivotListModel[] = new Array<PerformancePivotListModel>();   holi

    genericDataModel: any;
    requestedParams: any; 
    formMetadata : any = {};
    formMetadataDetails : any[] = [];
 
    //events fired when the service changes the underlying data, for example,then http response update the data store
    @Output() CreateReportEvent: EventEmitter<ReportModel> = new EventEmitter<ReportModel>(true);
    @Output() getPdfReportEvent: EventEmitter<string> = new EventEmitter<string>(true);
    @Output() TransactionsChangedEvent: EventEmitter<TransactionModel[]> = new EventEmitter<TransactionModel[]>(true);
    @Output() CrossRatesChangedEvent: EventEmitter<CrossRatesModel[]> = new EventEmitter<CrossRatesModel[]>(true);
    @Output() TransactionsVolumeChangedEvent: EventEmitter<TransactionVolumeModel[]> = new EventEmitter<TransactionVolumeModel[]>(true);
    @Output() PortfolioPerformanceDetailsEvent: EventEmitter<PortfolioPerformanceDetailsModel[]> = new EventEmitter<PortfolioPerformanceDetailsModel[]>(true);
    @Output() NewsDataEvent: EventEmitter<NewsDataModel[]> = new EventEmitter<NewsDataModel[]>(true);
    @Output() SecurityPricesChartEvent: EventEmitter<SecurityPricesModel[]> = new EventEmitter<SecurityPricesModel[]>(true);
    @Output() PortfolioEvent: EventEmitter<PortfolioModel[]> = new EventEmitter<PortfolioModel[]>(true);
    @Output() AssetCategoryChartEvent: EventEmitter<ChartModel[]> = new EventEmitter<ChartModel[]>(true);
    @Output() CurrencyAnalysisChartEvent: EventEmitter<ChartModel[]> = new EventEmitter<ChartModel[]>(true);
    @Output() PerformanceDetailsChartEvent: EventEmitter<ChartModel[]> = new EventEmitter<ChartModel[]>(true);
    @Output() PerformancePivotListEvent: EventEmitter<PerformancePivotListModel[]> = new EventEmitter<PerformancePivotListModel[]>(true);

    constructor(private _appStateProvider: appStateProvider, private http: HttpClient, private _authService: AuthService, private _localize: LocalizeService) {
        this.language = this._localize.getLocale().substring(0, 2);
        this.stateSubscription = _appStateProvider.subscribe(eventdata => this.initDataFetching(eventdata));
        this.authServiceSubscription = this._authService.LoggedInStatusChangedEmitter.subscribe((loggedIn) => {
            if (loggedIn.value === false) {
                let multiselect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
                if (multiselect) {
                    multiselect.destroy();
                }
                this.clearData();
                this.newsData = [];
            } else {
                // load localization after login
                this.language = this._localize.getLocale().substring(0, 2);
            }
        });
    }

    clearData() {
        this.portfolios = [];
        this.report = undefined;
        this.chartDataAssetCategory = [];
        this.chartDataPerformanceDetails = [];
        this.chartDataCurrAnalysis = [];
        this.transactions = []
        this.crossRates = [];
        this.maxValPerformanceDetails = null;
        this.minValPerformanceDetails = null;
        this.currencies = [];
        this.transactionVolume = [];
        this.portfolioPerformanceDetails = [];
        this.allPortfoliosNoLiquidity = [];
        this.pdfReport = "";
        this.performancePivotList = [];
        // emit events
        this.CurrencyAnalysisChartEvent.emit(this.chartDataCurrAnalysis);
        this.AssetCategoryChartEvent.emit(this.chartDataAssetCategory);
        this.PerformanceDetailsChartEvent.emit(this.chartDataPerformanceDetails);
        this.CrossRatesChangedEvent.emit(this.crossRates);
        this.PortfolioEvent.emit(this.portfolios);
        this.TransactionsVolumeChangedEvent.emit(this.transactionVolume);
        this.PortfolioPerformanceDetailsEvent.emit(this.portfolioPerformanceDetails);
        this.CreateReportEvent.emit(this.report);
        this.getPdfReportEvent.emit(this.pdfReport);
        this.TransactionsChangedEvent.emit(this.transactions);
    }

    initDataFetching(e) {
        this.language = this._localize.getLocale().substring(0, 2);
        if ((this._appStateProvider.selectedPartner.value === 0 && this._appStateProvider.selectedPortfolios.length > 0) || this._appStateProvider.selectedPortfolios.length > 0) {
            this.createReport();
            this.getTransactions();
        } else {
            this.clearData();
        }
        this.getNewsData();
    }

    getCurrencies(): Observable<CurrencyModel[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        let req = this.http.get<CurrencyModel[]>(
            this.hostAddress + this.servicesURL + '/Currencies' + '?language=' + this.language + '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get currency list")))
        //.map(res => res.json()); holi
        req.subscribe(data => {
            this.currencies = data;
        });
        return req;
    };

    getPortfolio(): Observable<PortfolioModel> {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();
        let req = this.http.get<PortfolioModel>(
            this.hostAddress + this.servicesURL + '/Portfolio?SessionID=' + this._authService.sessionId + '&language=' + this.language + '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get portfolio")))
        //.map(res => res.json());
        req.subscribe(data => {
            this.portfolios = data;

            let portfoliosWithoutLiquidity = [];
           
                this.portfolios.forEach(portf => {
                    if (portf.SecMainClass !== appConfig.SecMainClass_LIQUIDITY) {
                        portfoliosWithoutLiquidity.push(portf);
                    }
                });
                portfoliosWithoutLiquidity.sort(function (a, b) {
                    let p1 = a.SecName.toUpperCase();
                    let p2 = b.SecName.toUpperCase();
                    return (p1 < p2) ? -1 : (p1 > p2) ? 1 : 0;
                });
    
                this.allPortfoliosNoLiquidity = portfoliosWithoutLiquidity;
                this.PortfolioEvent.emit(this.portfolios);
                this._appStateProvider.fetchingPortfolios = false;
        });
        return req;
    };

    getSecPricesChart(secNumber, secIndex: number = 0) {
    let headers = this._authService.getAuthHeaders('application/json');
    let timeStamp = +new Date();

    let req = this.http.get(
        this.hostAddress + this.servicesURL 
        + '/SecurityPricesWithVolume'
        + '?SecurityNumber=' + encodeURIComponent(secNumber)
        + '&secIndex=' + secIndex
        + '&' + this.getPortfoliosForHttpQuery()
        + '&tsp=' + timeStamp,
        { headers }
            ).pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not load security"))
            );

    req.subscribe(data => {
        this.secPrices = data;
        this.SecurityPricesChartEvent.emit(this.secPrices);
        this._appStateProvider.fetchingSecurityPrices = false;
    });

    return req;
}


    getAssetCategoryChart(){
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        this.http.get(
            this.hostAddress + this.servicesURL + '/ChartDataForAssetCategory?sessionID=' + this._authService.sessionId + '&language=' + this.language+ '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not load asset category chart.")))
            //.map(res => res.json())
            .subscribe((data: ChartModel[]) => {
                this.chartDataAssetCategory = data,
                    this.AssetCategoryChartEvent.emit(this.chartDataAssetCategory),
                    this._appStateProvider.fetchingAssetCategory = false
            })
    };

    getCurrencyAnalysisChart() {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();
      
        this.http.get(
            this.hostAddress + this.servicesURL + '/ChartDataForCurrencyAnalysis?sessionID=' + this._authService.sessionId + '&language=' + this.language+ '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not load currency analysis chart")))
            //.map(res => res.json())
            .subscribe((data: ChartModel[]) => {
                this.chartDataCurrAnalysis = data,
                    this.CurrencyAnalysisChartEvent.emit(this.chartDataCurrAnalysis),
                    this._appStateProvider.fetchingCurrAnalysis = false
            });
    };

    getPerformanceDetailChart() {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();
      
        this.http.get(
            this.hostAddress + this.servicesURL + '/ChartDataForPerformanceDetails?SessionID=' + this._authService.sessionId + '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get performance details")))
            //.map(res => res.json())
            .subscribe((data: ChartModel[]) => {
                this.chartDataPerformanceDetails = data;
                this.PerformanceDetailsChartEvent.emit(this.chartDataPerformanceDetails);
                this._appStateProvider.fetchingPerfomanceBarChart = false;
            })
    };

    getTransactions() {
        this._appStateProvider.fetchingTransactions = true;
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        let req = this.http.get(
            this.hostAddress + this.servicesURL + '/TransactionsV2?PartnerID=' + this._appStateProvider.selectedPartner.value + '&' + this.getPortfoliosForHttpQuery() + '&fromDate=' + this.getDateString(this._appStateProvider.startDate) + '&toDate=' + this.getDateString(this._appStateProvider.endDate) 
            + '&language=' + this.language+ '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not load transactions")))
            //.map(res => res.json())
            .subscribe(data => {
                this.transactions = data;
                this.TransactionsChangedEvent.emit(this.transactions);
                this._appStateProvider.fetchingTransactions = false;
            })
        return req;
    };

    getTransactionsVolume() {
        this._appStateProvider.fetchingTransVolume = true;
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();
      
        this.http.get(
            this.hostAddress + this.servicesURL + '/PortfolioTransactionsVolumeV2?PartnerID=' + this._appStateProvider.selectedPartner.value + '&' + this.getPortfoliosForHttpQuery() + '&fromDate=' + this.getDateString(this._appStateProvider.startDate) + '&toDate=' + this.getDateString(this._appStateProvider.endDate) + '&sessionID=' + this._authService.sessionId
            + '&language=' + this.language+ '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get transaction volume list")))
            //.map(res => res.json())
            .subscribe((data: TransactionVolumeModel[]) => {
                this.transactionVolume = data,
                    this.TransactionsVolumeChangedEvent.emit(this.transactionVolume),
                    this._appStateProvider.fetchingTransVolume = false
            }
            , err => this.handleError
            )
    }

    getExchangeRates() {
        this._appStateProvider.fetchingCrossRates = true;
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();
       
        let req = this.http.get(
            this.hostAddress + this.servicesURL + '/PortalCrossRates?rateDate=' + this.getDateString(this._appStateProvider.endDate) + '&sessionID=' + this._authService.sessionId+ '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get exchange rates")))
            //.map(res => res.json())
            .subscribe((data: CrossRatesModel[]) => {
                this.crossRates = data;
                this.CrossRatesChangedEvent.emit(this.crossRates);
                this._appStateProvider.fetchingCrossRates = false;
            },
            error => this.handleError
            )
    }

    getPortfolioPerformanceDetails() {
        this._appStateProvider.fetchingPortfolioDetails = true;
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        this.http.get(
            this.hostAddress + this.servicesURL + '/PortfolioPerformanceDetails?SessionID=' + this._authService.sessionId+ '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get portfolio performance details.")))
            //.map(res => res.json())
            .subscribe((data: PortfolioPerformanceDetailsModel[]) => {
                this.portfolioPerformanceDetails = data;
                this.PortfolioPerformanceDetailsEvent.emit(this.portfolioPerformanceDetails);
                this._appStateProvider.fetchingPortfolioDetails = false;
            });
    }

    getLanguages() {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        return this.http.get(
            `${this.hostAddress}/RiskAssessment/Languages?SessionID=${this._authService.sessionId}&tsp=${timeStamp}`,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Error getting language.")))
            //.map(res => res.json())
            .toPromise();
    }

    compareParams(p1, p2) {
        return Object.keys(p1).every(key => p1[key] === p2[key])
    }

    createReportParams() {
        return {
            reportByPartner: this._appStateProvider.reportByPartner,
            selectedPartnerValue: this._appStateProvider.selectedPartner.value,
            portfolios: this.getPortfoliosForHttpQuery(),
            startDate: this.getDateString(this._appStateProvider.startDate),
            endDate: this.getDateString(this._appStateProvider.endDate),
            selectedCurrencyValue: this._appStateProvider.selectedCurrency.value,
            includeIgnoredTransactions: this._appStateProvider.includeIgnoredTransactions
        }
    }

    createReport() {
        this._appStateProvider.fetchingReport = true;
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        this.requestedParams = this.createReportParams();
        let req = this.http.get(
            this.hostAddress + this.servicesURL + '/CreateReport?ReportByPartner=' + this._appStateProvider.reportByPartner + '&PartnerIndex=' + this._appStateProvider.selectedPartner.value + '&' + this.getPortfoliosForHttpQuery()
            + '&StartDate=' + this.getDateString(this._appStateProvider.startDate)
            + '&EndDate=' + this.getDateString(this._appStateProvider.endDate) + '&CurrencyIndex=' + this._appStateProvider.selectedCurrency.value + '&sessionID=' + this._authService.sessionId + '&PDFasBase64=true' + '&IncludeIgnored=' + this._appStateProvider.includeIgnoredTransactions
            + '&language=' + this.language+ '&tsp=' + timeStamp + '&forceProcessingOnPortfolioLevel=' + this._appStateProvider.forceProcessingOnPortfolioLevel ,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not create report.")))
            /*.map((res) => {
                return res.json();
            });*/

        req.subscribe((data: ReportModel[]) => {
            if (data === null) {
                this.report = new ReportModel();
                this.clearData();
            } else {
                this.report = data;
                this.getAssetCategoryChart();
                this.getCurrencyAnalysisChart();
                this.getPerformanceDetailChart();
                this.getExchangeRates();
                this.getPortfolio();
                this.getTransactionsVolume();
                this.getPortfolioPerformanceDetails();
                //on embedded system, do not trigger automatic PDF creation, as we do not show it
                if (!this._authService.embeddedToken){
                    this.getPDFReport();
                }
                this.CreateReportEvent.emit(this.report);
            }
            this._appStateProvider.fetchingReport = false;
        }
            , error => this.handleError)

    };

    getPDFReport(reportType: number = -1) {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        this._appStateProvider.fetchingPDF = true;
        let req = this.http.get(
            this.hostAddress + this.servicesURL + '/GetPDFReport?ReportByPartner=' + this._appStateProvider.reportByPartner + '&PartnerIndex=' + this._appStateProvider.selectedPartner.value + '&' + this.getPortfoliosForHttpQuery()
            + '&StartDate=' + this.getDateString(this._appStateProvider.startDate)
            + '&EndDate=' + this.getDateString(this._appStateProvider.endDate) + '&CurrencyIndex=' + this._appStateProvider.selectedCurrency.value + '&sessionID=' + this._authService.sessionId + '&reportType=' + reportType
            + '&IncludeIgnored=' + this._appStateProvider.includeIgnoredTransactions
            + '&language=' + this.language + '&tsp=' + timeStamp
            + '&forceProcessingOnPortfolioLevel=' + this._appStateProvider.forceProcessingOnPortfolioLevel,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Error getting report type " + reportType)))
            /*.map((res) => {
                return res.json();
            });*/

        req.subscribe((data: string) => {
            // prevent loading of PDF if the selected portfolio changed in the meantime
            // this happens when you choose 1005002 as partner and then quickly switch to 1005001 which doesn't have portfolio
            let currentParams = this.createReportParams()
            let paramsAreSame = this.compareParams(this.requestedParams, currentParams);
            if (data === null || !paramsAreSame) {
                this.pdfReport = "";
            } else {
                this.pdfReport = data;
            }
            if (!paramsAreSame) {
                console.log('Prevented display of wrong PDF!');
            }
            this._appStateProvider.fetchingPDF = false;
            this.getPdfReportEvent.emit(this.pdfReport);
        }
            , error => this.handleError)

    };

    getPortfoliosForHttpQuery() {
        let portfList: string = "";
        let i: number = 0;
        this._appStateProvider.selectedPortfolios.forEach(element => {
            portfList = portfList + 'portfolios[' + i + ']=' + element + '&';
            i++;
        });
        portfList = portfList.slice(0, -1);
        return portfList;
    }


    getNewsData() {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        let req = this.http.get(this.hostAddress + this.servicesURL + '/NewsData?partnerIndex=' + this._appStateProvider.selectedPartner.value + '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get news data")))
            //.map(res => res.json())
        req.subscribe((data: NewsDataModel[]) => {
            this.newsData = data,
                this.NewsDataEvent.emit(this.newsData),
                this._appStateProvider.fetchingNews = false
        });
        return req;
    }

    getEntriesFromNavigatorSettings(type: string) {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        let req = this.http.get(this.hostAddress + this.servicesURL + '/NavigatorSettings?type=' + type + '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get entries from navigator settings")))
            //.map(res => res.json())
        return req;
    }

    getPerformancePivotList(): Observable<PerformancePivotListModel[]> {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();
  
        let req = this.http.get<PerformancePivotListModel[]>(
            this.hostAddress + this.servicesURL + '/PerformancePivotList'+ '?tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Error loading pivot performance")))
            //.map(res => res.json())
        req.subscribe(data => {
            this.performancePivotList = data
            this.PerformancePivotListEvent.emit(data)
            //this._appStateProvider.fetchingSecurityPrices = false;
        });
        return req;
    }

    getReportTypes() {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        let req = this.http.get(this.hostAddress + this.servicesURL + '/GetReportTypes'+ '?tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Error loading report types.")))
            //.map(res => res.json())
        return req;
    }

    getDateString(datevalue: Date): string {
        let mm: string;
        mm = (datevalue.getMonth() + 1).toString();
        mm = '0'.repeat(2 - mm.length) + mm;

        return datevalue.getFullYear() + "-" + mm + "-" + datevalue.getDate();
    }

    private handleError(error: any, message: string) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
            SharedMethodsModule.addNotification("#notification", message, false); 
        return observableThrowError(errMsg);
    }

    ngOnDestroy() {
        this.stateSubscription.unsubscribe();
        this.authServiceSubscription.unsubscribe();
    }
}






// WEBPACK FOOTER //
// ./app/insa-services/insa.service.ts